import { UserRolesEnumLabels,ROStatusEnumLabels } from "../enum/enums";

export const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

export const getRoleName = (userRole) => {
  return UserRolesEnumLabels[userRole];
};

export const convertTimeToISO = (time12hr) => {
  const today = new Date();
  const isoDate = today.toISOString();
  const datePart = isoDate.split("T")[0];
  let [time, period] = time12hr.split(" ");
  let [hours, minutes] = time.split(":");  
  hours = period === "PM" && hours !== "12" ? parseInt(hours) + 12 : hours;
  hours = period === "AM" && hours === "12" ? "00" : hours;  
  hours = String(hours).padStart(2, "0"); 
  const newTime = `${hours}:00:00`; 
  const newISODate = `${datePart}T${newTime}.000Z`;
  return newISODate;
};
export const findEndTime = (isoDate, hoursToAdd) => {
  const date = new Date(isoDate);
  date.setTime(date.getTime() + hoursToAdd * 3600000);
  return date.toISOString();
};


export const convertTo24Hour = (time) => {
  let [hour, period] = time.split(' ');
  hour = parseInt(hour);
  
  if (period === 'PM' && hour !== 12) {
    hour += 12;
  } else if (period === 'AM' && hour === 12) {
    hour = 0; // Midnight case
  }
  
  return hour;
};
export const getRoStatusName = (rostatus) => {
  return ROStatusEnumLabels[rostatus];
};
